// extracted by mini-css-extract-plugin
export default {"instructions":"instructions__Aj_d8zIMC_8rxFXo3UyO","instructionsTitle":"instructionsTitle__OcRNShfTKy70FLZes40Y"};